var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConsoleIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 161 112",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "square",
      strokeMiterlimit: 1.5
    },
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "console-illustration"
  }, "Illustration eines Mischpults") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "console-illustration"
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "console"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.11172,0,0,0.754379,-14.2953,23.9866)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.635,100.308C71.635,98.845 71.211,97.657 70.688,97.657L7.717,97.657C7.194,97.657 6.77,98.845 6.77,100.308C6.77,101.771 7.194,102.959 7.717,102.959L70.688,102.959C71.211,102.959 71.635,101.771 71.635,100.308Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.177112,0,0,0.754379,148.313,23.9866)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.635,100.308C71.635,98.845 66.575,97.657 60.343,97.657L18.062,97.657C11.829,97.657 6.77,98.845 6.77,100.308C6.77,101.771 11.829,102.959 18.062,102.959L60.343,102.959C66.575,102.959 71.635,101.771 71.635,100.308Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.8879,0,0,2.14708,-26.3525,-18.2457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.239,10.114C99.239,9.258 98.448,8.563 97.475,8.563L15.722,8.563C14.749,8.563 13.959,9.258 13.959,10.114L13.959,56.098C13.959,56.098 14.106,58.016 14.488,58.71C14.866,59.396 15.279,60.261 16.252,60.261L96.945,60.261C97.918,60.261 98.331,59.396 98.709,58.71C99.091,58.016 99.239,56.098 99.239,56.098L99.239,10.114ZM97.12,10.426L97.12,56.087C97.102,56.448 97.032,57.48 96.802,57.898C96.729,58.03 96.6,58.244 96.505,58.398L16.692,58.398C16.597,58.244 16.468,58.03 16.395,57.898C16.165,57.48 16.095,56.447 16.078,56.094L16.077,10.426L97.12,10.426Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "track_5",
    transform: "matrix(1,0,0,1,97.2809,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fader"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.17872,0,0,1.99441,-2.70282,-50.2038)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.959,
    y: 49.917,
    width: 3.394,
    height: 20.248
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.805479,0,0,0.641508,-19.2911,35.9021)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35.6,
    y: 55.64,
    width: 9.954,
    height: 20.86,
    style: {
      fill: "#00adef",
      stroke: "black",
      strokeWidth: "5.49px"
    }
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(8.44239e-17,1.37875,-0.754379,4.61924e-17,101.202,-2.90995)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.635,100.308C71.635,98.845 70.985,97.657 70.185,97.657L8.22,97.657C7.42,97.657 6.77,98.845 6.77,100.308C6.77,101.771 7.42,102.959 8.22,102.959L70.185,102.959C70.985,102.959 71.635,101.771 71.635,100.308Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-3.11856,-3.81771)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.512,17C20.648,17 24.006,20.358 24.006,24.494C24.006,28.63 20.648,31.988 16.512,31.988C12.376,31.988 9.018,28.63 9.018,24.494C9.018,20.358 12.376,17 16.512,17ZM16.512,21C18.44,21 20.006,22.566 20.006,24.494C20.006,26.422 18.44,27.988 16.512,27.988C14.583,27.988 13.018,26.422 13.018,24.494C13.018,22.566 14.583,21 16.512,21Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-3.11856,14.1397)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.512,17C20.648,17 24.006,20.358 24.006,24.494C24.006,28.63 20.648,31.988 16.512,31.988C12.376,31.988 9.018,28.63 9.018,24.494C9.018,20.358 12.376,17 16.512,17ZM16.512,21C18.44,21 20.006,22.566 20.006,24.494C20.006,26.422 18.44,27.988 16.512,27.988C14.583,27.988 13.018,26.422 13.018,24.494C13.018,22.566 14.583,21 16.512,21Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "track_4",
    transform: "matrix(1,0,0,1,72.9607,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fader1"
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.17872,0,0,1.99441,-2.70282,-50.2038)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.959,
    y: 49.917,
    width: 3.394,
    height: 20.248
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.810668,0,0,0.62841,-19.5017,25.0938)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35.6,
    y: 55.64,
    width: 9.954,
    height: 20.86,
    style: {
      fill: "#00adef",
      stroke: "black",
      strokeWidth: "5.52px"
    }
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(8.44239e-17,1.37875,-0.754379,4.61924e-17,101.202,-2.90995)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.635,100.308C71.635,98.845 70.985,97.657 70.185,97.657L8.22,97.657C7.42,97.657 6.77,98.845 6.77,100.308C6.77,101.771 7.42,102.959 8.22,102.959L70.185,102.959C70.985,102.959 71.635,101.771 71.635,100.308Z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-3.11856,-3.81771)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.512,17C20.648,17 24.006,20.358 24.006,24.494C24.006,28.63 20.648,31.988 16.512,31.988C12.376,31.988 9.018,28.63 9.018,24.494C9.018,20.358 12.376,17 16.512,17ZM16.512,21C18.44,21 20.006,22.566 20.006,24.494C20.006,26.422 18.44,27.988 16.512,27.988C14.583,27.988 13.018,26.422 13.018,24.494C13.018,22.566 14.583,21 16.512,21Z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-3.11856,14.1397)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.512,17C20.648,17 24.006,20.358 24.006,24.494C24.006,28.63 20.648,31.988 16.512,31.988C12.376,31.988 9.018,28.63 9.018,24.494C9.018,20.358 12.376,17 16.512,17ZM16.512,21C18.44,21 20.006,22.566 20.006,24.494C20.006,26.422 18.44,27.988 16.512,27.988C14.583,27.988 13.018,26.422 13.018,24.494C13.018,22.566 14.583,21 16.512,21Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "track_3",
    transform: "matrix(1,0,1.2326e-32,1,48.6404,-7.10543e-15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fader2"
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.17872,0,0,1.99441,-2.70282,-50.2038)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.959,
    y: 49.917,
    width: 3.394,
    height: 20.248
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.810668,0,-7.74575e-33,0.62841,-19.5017,19.2117)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35.6,
    y: 55.64,
    width: 9.954,
    height: 20.86,
    style: {
      fill: "#00adef",
      stroke: "black",
      strokeWidth: "5.52px"
    }
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(8.44239e-17,1.37875,-0.754379,4.61924e-17,101.202,-2.90995)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.635,100.308C71.635,98.845 70.985,97.657 70.185,97.657L8.22,97.657C7.42,97.657 6.77,98.845 6.77,100.308C6.77,101.771 7.42,102.959 8.22,102.959L70.185,102.959C70.985,102.959 71.635,101.771 71.635,100.308Z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-3.11856,-3.81771)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.512,17C20.648,17 24.006,20.358 24.006,24.494C24.006,28.63 20.648,31.988 16.512,31.988C12.376,31.988 9.018,28.63 9.018,24.494C9.018,20.358 12.376,17 16.512,17ZM16.512,21C18.44,21 20.006,22.566 20.006,24.494C20.006,26.422 18.44,27.988 16.512,27.988C14.583,27.988 13.018,26.422 13.018,24.494C13.018,22.566 14.583,21 16.512,21Z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-3.11856,14.1397)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.512,17C20.648,17 24.006,20.358 24.006,24.494C24.006,28.63 20.648,31.988 16.512,31.988C12.376,31.988 9.018,28.63 9.018,24.494C9.018,20.358 12.376,17 16.512,17ZM16.512,21C18.44,21 20.006,22.566 20.006,24.494C20.006,26.422 18.44,27.988 16.512,27.988C14.583,27.988 13.018,26.422 13.018,24.494C13.018,22.566 14.583,21 16.512,21Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "track_2",
    transform: "matrix(1,0,0,1,24.3202,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fader3"
  }, _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.17872,0,0,1.99441,-2.70282,-50.2038)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.959,
    y: 49.917,
    width: 3.394,
    height: 20.248
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.799272,0,0,0.636539,-19.0393,33.4251)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35.6,
    y: 55.64,
    width: 9.954,
    height: 20.86,
    style: {
      fill: "#00adef",
      stroke: "black",
      strokeWidth: "5.54px"
    }
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(8.44239e-17,1.37875,-0.754379,4.61924e-17,101.202,-2.90995)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.635,100.308C71.635,98.845 70.985,97.657 70.185,97.657L8.22,97.657C7.42,97.657 6.77,98.845 6.77,100.308C6.77,101.771 7.42,102.959 8.22,102.959L70.185,102.959C70.985,102.959 71.635,101.771 71.635,100.308Z"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-3.11856,-3.81771)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.512,17C20.648,17 24.006,20.358 24.006,24.494C24.006,28.63 20.648,31.988 16.512,31.988C12.376,31.988 9.018,28.63 9.018,24.494C9.018,20.358 12.376,17 16.512,17ZM16.512,21C18.44,21 20.006,22.566 20.006,24.494C20.006,26.422 18.44,27.988 16.512,27.988C14.583,27.988 13.018,26.422 13.018,24.494C13.018,22.566 14.583,21 16.512,21Z"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-3.11856,14.1397)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.512,17C20.648,17 24.006,20.358 24.006,24.494C24.006,28.63 20.648,31.988 16.512,31.988C12.376,31.988 9.018,28.63 9.018,24.494C9.018,20.358 12.376,17 16.512,17ZM16.512,21C18.44,21 20.006,22.566 20.006,24.494C20.006,26.422 18.44,27.988 16.512,27.988C14.583,27.988 13.018,26.422 13.018,24.494C13.018,22.566 14.583,21 16.512,21Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "track_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fader4"
  }, _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.17872,0,0,1.99441,-2.70282,-50.2038)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.959,
    y: 49.917,
    width: 3.394,
    height: 20.248
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.809808,0,0,0.633817,-19.4668,27.8134)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35.6,
    y: 55.64,
    width: 9.954,
    height: 20.86,
    style: {
      fill: "#00adef",
      stroke: "black",
      strokeWidth: "5.5px"
    }
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(8.44239e-17,1.37875,-0.754379,4.61924e-17,101.202,-2.90995)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.635,100.308C71.635,98.845 70.985,97.657 70.185,97.657L8.22,97.657C7.42,97.657 6.77,98.845 6.77,100.308C6.77,101.771 7.42,102.959 8.22,102.959L70.185,102.959C70.985,102.959 71.635,101.771 71.635,100.308Z"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-3.11856,-3.81771)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.512,17C20.648,17 24.006,20.358 24.006,24.494C24.006,28.63 20.648,31.988 16.512,31.988C12.376,31.988 9.018,28.63 9.018,24.494C9.018,20.358 12.376,17 16.512,17ZM16.512,21C18.44,21 20.006,22.566 20.006,24.494C20.006,26.422 18.44,27.988 16.512,27.988C14.583,27.988 13.018,26.422 13.018,24.494C13.018,22.566 14.583,21 16.512,21Z"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-3.11856,14.1397)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.512,17C20.648,17 24.006,20.358 24.006,24.494C24.006,28.63 20.648,31.988 16.512,31.988C12.376,31.988 9.018,28.63 9.018,24.494C9.018,20.358 12.376,17 16.512,17ZM16.512,21C18.44,21 20.006,22.566 20.006,24.494C20.006,26.422 18.44,27.988 16.512,27.988C14.583,27.988 13.018,26.422 13.018,24.494C13.018,22.566 14.583,21 16.512,21Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "master_track"
  }, /*#__PURE__*/React.createElement("g", {
    id: "knob"
  }, _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.41304,0,0,1.5242,-63.7912,-12.9106)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.537,56.018C155.537,55.294 154.903,54.706 154.122,54.706L136.139,54.706C135.358,54.706 134.724,55.294 134.724,56.018C134.724,56.742 135.358,57.33 136.139,57.33L154.122,57.33C154.903,57.33 155.537,56.742 155.537,56.018Z"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.999173,0.999173,-1.07777,1.07777,56.6488,-132.913)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.537,56.018C155.537,55.294 154.903,54.706 154.122,54.706L136.139,54.706C135.358,54.706 134.724,55.294 134.724,56.018C134.724,56.742 135.358,57.33 136.139,57.33L154.122,57.33C154.903,57.33 155.537,56.742 155.537,56.018Z"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,1.41304,-1.5242,0,226.667,-132.603)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.537,56.018C155.537,55.294 154.903,54.706 154.122,54.706L136.139,54.706C135.358,54.706 134.724,55.294 134.724,56.018C134.724,56.742 135.358,57.33 136.139,57.33L154.122,57.33C154.903,57.33 155.537,56.742 155.537,56.018Z"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.999173,0.999173,-1.07777,-1.07777,346.67,-12.1635)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.537,56.018C155.537,55.294 154.903,54.706 154.122,54.706L136.139,54.706C135.358,54.706 134.724,55.294 134.724,56.018C134.724,56.742 135.358,57.33 136.139,57.33L154.122,57.33C154.903,57.33 155.537,56.742 155.537,56.018Z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.683309,0,0,0.683309,39.9638,18.5928)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 148.23,
    cy: 78.851,
    r: 15.18,
    style: {
      fill: "#00adef",
      stroke: "black",
      strokeWidth: "5.85px",
      strokeLinejoin: "bevel"
    }
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1.14063,-0.0339379,-13.0108)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 139.284,
    y: 65.751,
    width: 4,
    height: 7.413
  })))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "master_indicator"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.14118,0,0,1,-26.5787,-4.97716)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.935,21.311C144.935,20.799 144.57,20.383 144.122,20.383L138.055,20.383C137.607,20.383 137.243,20.799 137.243,21.311L137.243,23.166C137.243,23.678 137.607,24.093 138.055,24.093L144.122,24.093C144.57,24.093 144.935,23.678 144.935,23.166L144.935,21.311Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.14118,0,0,1,-26.5787,7.59696)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.935,21.311C144.935,20.799 144.57,20.383 144.122,20.383L138.055,20.383C137.607,20.383 137.243,20.799 137.243,21.311L137.243,23.166C137.243,23.678 137.607,24.093 138.055,24.093L144.122,24.093C144.57,24.093 144.935,23.678 144.935,23.166L144.935,21.311Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.14118,0,0,1,-26.5787,20.1711)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.935,21.311C144.935,20.799 144.57,20.383 144.122,20.383L138.055,20.383C137.607,20.383 137.243,20.799 137.243,21.311L137.243,23.166C137.243,23.678 137.607,24.093 138.055,24.093L144.122,24.093C144.57,24.093 144.935,23.678 144.935,23.166L144.935,21.311Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.14118,0,0,1,-12.2592,-4.97716)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.935,21.311C144.935,20.799 144.57,20.383 144.122,20.383L138.055,20.383C137.607,20.383 137.243,20.799 137.243,21.311L137.243,23.166C137.243,23.678 137.607,24.093 138.055,24.093L144.122,24.093C144.57,24.093 144.935,23.678 144.935,23.166L144.935,21.311Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.14118,0,0,1,-12.2592,7.59696)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.935,21.311C144.935,20.799 144.57,20.383 144.122,20.383L138.055,20.383C137.607,20.383 137.243,20.799 137.243,21.311L137.243,23.166C137.243,23.678 137.607,24.093 138.055,24.093L144.122,24.093C144.57,24.093 144.935,23.678 144.935,23.166L144.935,21.311Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.14118,0,0,1,-12.2592,20.1711)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.935,21.311C144.935,20.799 144.57,20.383 144.122,20.383L138.055,20.383C137.607,20.383 137.243,20.799 137.243,21.311L137.243,23.166C137.243,23.678 137.607,24.093 138.055,24.093L144.122,24.093C144.57,24.093 144.935,23.678 144.935,23.166L144.935,21.311Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.976471,0,0,1,11.6124,13.203)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.935,21.311C144.935,20.799 144.509,20.383 143.985,20.383L138.193,20.383C137.668,20.383 137.243,20.799 137.243,21.311L137.243,23.166C137.243,23.678 137.668,24.093 138.193,24.093L143.985,24.093C144.509,24.093 144.935,23.678 144.935,23.166L144.935,21.311Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.976471,0,0,1,11.6124,1.07688)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.935,21.311C144.935,20.799 144.509,20.383 143.985,20.383L138.193,20.383C137.668,20.383 137.243,20.799 137.243,21.311L137.243,23.166C137.243,23.678 137.668,24.093 138.193,24.093L143.985,24.093C144.509,24.093 144.935,23.678 144.935,23.166L144.935,21.311Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.976471,0,0,1,-3.34061,13.203)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.935,21.311C144.935,20.799 144.509,20.383 143.985,20.383L138.193,20.383C137.668,20.383 137.243,20.799 137.243,21.311L137.243,23.166C137.243,23.678 137.668,24.093 138.193,24.093L143.985,24.093C144.509,24.093 144.935,23.678 144.935,23.166L144.935,21.311Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.976471,0,0,1,-3.34061,1.07688)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.935,21.311C144.935,20.799 144.509,20.383 143.985,20.383L138.193,20.383C137.668,20.383 137.243,20.799 137.243,21.311L137.243,23.166C137.243,23.678 137.668,24.093 138.193,24.093L143.985,24.093C144.509,24.093 144.935,23.678 144.935,23.166L144.935,21.311Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.10762,0,0,1.07574,-15.5185,-1.63667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.268,10.783C152.268,10.428 151.988,10.139 151.642,10.139L132.04,10.139C131.695,10.139 131.415,10.428 131.415,10.783L131.415,47.729C131.415,48.084 131.695,48.373 132.04,48.373L151.642,48.373C151.988,48.373 152.268,48.084 152.268,47.729L152.268,10.783ZM135.026,13.857L135.026,44.654L148.657,44.654L148.657,13.857L135.026,13.857Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsoleIllustration);
export default __webpack_public_path__ + "static/media/console_illustration.19c93669.svg";
export { ForwardRef as ReactComponent };